import React, { useState, useContext, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';
import CountryContext from '../../context/country';
import { analytics } from '../../utils/index';

import LeadTime from './LeadTime';
import Price from './Price';

import styles from './BundleProduct.module.css';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/400x400`;

const transitionProps = {
  timeout: 5000,
  classNames: {
    enter: styles['fade-enter'],
    enterActive: styles['fade-enter-active'],
    exit: styles['fade-leave'],
    exitActive: styles['fade-leave-active']
  }
};

const BundleProduct = ({
  baseUrl,
  product,
  manualEntry,
  override,
  disableDirectSale
}) => {
  const { attributes, classes, media, name, price, url, sku } = product;

  const [t] = useTranslation();

  const { phoneNumberSales } = useContext(CountryContext);

  const to = `${baseUrl}${url}/`;
  const image =
    media && media.length
      ? media.filter(item => item.media_type === 'image')[0].file
      : attributes.image;
  const imageSrc = manualEntry ? image : `${cdnUrl}${image}`;
  const [text, setText] = useState(t('Call Us'));
  const [transition, setTransition] = useState(false);
  const [phoneinteraction, setPhoneinteraction] = useState(false);

  const updateText = text => {
    setText(phoneNumberSales);
    if (!phoneinteraction) {
      analytics.track('call_us_phone_number', {
        phone: phoneNumberSales
      });
    } else {
      analytics.track('call_us', {
        phone: phoneNumberSales
      });
    }
  };

  return (
    <section className={classes} styleName="product">
      <div styleName="image">
        {disableDirectSale ? (
          <img src={imageSrc} alt={name} />
        ) : (
          <Link to={to}>
            <img src={imageSrc} alt={name} />
          </Link>
        )}
      </div>
      <div styleName="body">
        <div styleName="name">
          {manualEntry ? name : <Link to={to}>{name}</Link>}
        </div>
        <Price
          styleName="price"
          price={price}
          isMinPrice={!manualEntry || override}
        />
        {product.specialContent ? (
          <div styleName="description">{product.specialContent}</div>
        ) : (
          <div
            styleName="description"
            dangerouslySetInnerHTML={{ __html: attributes.description }}
          />
        )}
      </div>
      {attributes.leadTime && attributes.leadTime > 0 ? (
        <LeadTime styleName="lead-time" value={attributes.leadTime} sku={sku} />
      ) : null}

      {disableDirectSale ? (
        <div styleName="action">
          <Button
            color="light"
            to={phoneinteraction ? `tel:${phoneNumberSales}` : null}
            onClick={() => {
              updateText(phoneNumberSales);
              setPhoneinteraction(true);
              setTransition(true);
            }}
          >
            <CSSTransition {...transitionProps} in={transition}>
              <Fragment>{text}</Fragment>
            </CSSTransition>
          </Button>
        </div>
      ) : (
        <div styleName="action">
          {manualEntry && !override ? (
            product.cta
          ) : (
            <Button to={to}>{t('Select')}</Button>
          )}
        </div>
      )}
    </section>
  );
};

export default DisplayComponent(BundleProduct);
